<template>
  <div class="pneu-fabricante ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            class="ml-5 mt-2"
            v-b-modal.modal-multi-fabricante
            @click="reset()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3"></div>
    <!--tbl de dados -->
    <b-table
      id="fabricante"
      small
      hover
      striped
      sticky-header="550px"
      :items="fabricante"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editFabricante(data.item)"
          title="Editar fabricante"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-fabricante
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA fabricante pneu -->
    <!--  MODAL GRAVAÇÃO RELACAO DA fabricante pneu -->
    <div>
      <b-modal
        id="modal-multi-fabricante"
        hide-footer
        size="lg"
        title="Cadastro de fabricantes"
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="6">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="fab.empresa_id"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="6">
              <label for="input-live">fabricante</label>
              <b-form-input
                v-model="fab.fabricante"
                placeholder="Digite a descrição do fabricante"
              ></b-form-input>
            </b-col>
          </b-row>
          <input id="id-fabricante" type="hidden" v-model="fab.id" />

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postfabricante(), reset()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: { ...mapState(["user"]) },
  name: "Manutencaofabricante",

  data: function () {
    return {
      carregando: false,
      empresas: [],
      fab: {},
      fabricante: [], // [] lista

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fields: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "id", label: "Id", sortable: true },
        { key: "fabricante", label: "fabricante", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, fabricante) => {
            return moment(fabricante.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data Alteracao",
          sortable: true,
          formatter: (value, key, fabricante) => {
            return moment(fabricante.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {},
  methods: {
    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadfabricante() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/fabricante`;
      axios.get(url, { params }).then((res) => {
        this.fabricante = res.data.map((fab) => {
          return { ...fab };
        });
      });
    },

    editFabricante(fab) {
      this.fab = { ...fab };
      this.loadEmpresa();
    },

    postfabricante() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${this.fab.empresa_id}`,
        id_funcionario: `${this.user.id_funcionario}`,
        id: `${this.fab.id}`,
        fabricante: `${this.fab.fabricante}`,
      };

      const url = `${baseApiUrl}/pneu/fabricante`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      this.fab = {};
      this.fabricante = [];
      this.loadfabricante();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadfabricante(); //    se habilitado carrega o grid
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#fabricantes {
  font-size: 0.9em;
  text-align: center;
}
</style>